import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import Close from "rialto-icons/Close";

import styles from "./Modal.css";

const ModalHeader = ({ children, isCloseable, onClose }) => (
  <div className={classnames(styles.block, styles.header)}>
    {children}
    {isCloseable && (
      <button onClick={onClose} type="button">
        <Close size="xs" />
      </button>
    )}
  </div>
);

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  isCloseable: PropTypes.bool,
};

ModalHeader.defaultProps = {
  isCloseable: true,
};

export default ModalHeader;
